import { ResourceType } from '../../../common/PricePrgClient';
import { createEpicFromAsyncAction, createEpicFromAsyncActionEmptyRequest, distinct } from '../../../utils';
import { fetchLoggableActionTypes } from '../../activitylog/redux/activityLogSlices';
import { fetchAgreements } from '../../agreement/redux/agreementSlices';
import { fetchCustomers } from '../../customer/redux/customerSlices';
import { fetchCustomerGroups } from '../../customergroups/redux/customerGroupSlices';
import { enqueueSnackbar } from '../../ui/redux/uiSlices';
import { fetchUserGroups } from '../../usergroup/redux/userGroupSlices';
import {
    fetchAvailablePermissions,
    fetchCurrentUserPermissions,
    fetchUsers,
    inviteExternalUser,
    inviteInternalUser,
    removeUserFromApp
} from './userSlices';

const getGuardedInitActions = (resourceType: ResourceType[]) =>
    resourceType
        .flatMap(getGuardedInitAction)
        .filter(distinct)
        .map(ac => ac());

const getGuardedInitAction = (resourceType: ResourceType) => {
    switch (resourceType) {
        case ResourceType.UserPage:
        case ResourceType.UserGroupPage:
            return [fetchUsers.request, fetchUserGroups.request, fetchAvailablePermissions.request];

        case ResourceType.CustomerPage:
            return [fetchCustomers.request];

        case ResourceType.AgreementPage:
            return [fetchAgreements.request, fetchCustomerGroups.request];

        case ResourceType.ActivityLogPage:
            return [fetchLoggableActionTypes.request];

        default:
            return [];
    }
};

const fetchUsers$ = createEpicFromAsyncActionEmptyRequest(fetchUsers, ({ userClient }) =>
    userClient.getAllUsers()
);

const fetchCurrentUserPermissions$ = createEpicFromAsyncAction(
    fetchCurrentUserPermissions,
    (payload, { userClient }) => userClient.getCurrentUserPermissions(),
    (affectedResources, resp) =>
        getGuardedInitActions(affectedResources == null ? resp.accessiblePages : affectedResources)
);

const fetchAvailablePermissions$ = createEpicFromAsyncActionEmptyRequest(
    fetchAvailablePermissions,
    ({ permissionClient }) => permissionClient.getAvailablePermissions()
);

const inviteInternalUser$ = createEpicFromAsyncAction(
    inviteInternalUser,
    (payload, { userClient }) => userClient.inviteUser(payload),
    undefined,
    (req, err) =>
        enqueueSnackbar({
            message: 'Failed to invite user: ' + err?.message,
            severity: 'error',
            autoHideDuration: 15000
        })
);

const inviteExternalUser$ = createEpicFromAsyncAction(
    inviteExternalUser,
    (payload, { userClient }) => userClient.inviteExternalUser(payload),
    undefined,
    (req, err) =>
        enqueueSnackbar({
            message: 'Failed to invite user: ' + err?.message,
            severity: 'error',
            autoHideDuration: 15000
        })
);

const removeUserFromApp$ = createEpicFromAsyncAction(removeUserFromApp, (payload, { userClient }) =>
    userClient.removeUser(payload)
);

export default [
    fetchUsers$,
    fetchCurrentUserPermissions$,
    fetchAvailablePermissions$,
    inviteInternalUser$,
    inviteExternalUser$,
    removeUserFromApp$
];
